import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '数据源限定',
    type: 'AMAR_DS_SCOPE',
    mapProp: 'map',
}